import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0A2540] text-gray-300 border-t border-[#2E2E2E]/20">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="md:col-span-2">
          <Link
  to="/"
  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
  className="inline-flex bg-white/90 backdrop-blur px-3 py-2 rounded-md shadow-sm mb-4"
>
  <img
    src="/images/fulllogo_transparent_nobuffer.png"
    alt="PulseShift Realty Partners"
    className="h-10 w-auto"
  />
</Link>
            <p className="text-sm leading-relaxed mb-4">
              Offshore Analyst Support for U.S. CRE
            </p>
            <p className="text-sm text-gray-400">
              Institutional-grade financial modeling, underwriting, and lease abstraction services.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/industries" className="hover:text-white transition-colors">Industries</Link></li>
              <li><Link to="/lease-abstractor" className="hover:text-white transition-colors">Lease Abstractor</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-sm">
              <li>
  Email:{' '}
  <a
    href="mailto:contact@pulseshiftrp.com"
    className="hover:text-white transition-colors"
  >
    contact@pulseshiftrp.com
  </a>
</li>
              <li>Location: India</li>
              <li>
  <Link
    to="/contact"
    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    className="text-[#4A6FA5] hover:text-white transition-colors"
  >
    Request Consultation
  </Link>
</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#2E2E2E]/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>© {new Date().getFullYear()} PulseShift Realty Partners. All rights reserved.</p>
            <p className="mt-2 md:mt-0">
              All analyses are provided for professional use and subject to client review.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
